"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNewState = void 0;
var immer_1 = __importDefault(require("immer"));
var FeatureInstanceStatus_1 = require("@phantom/ph-domain/dist/common/features/FeatureInstanceStatus");
var findFeatureById = function (features) { return function (id) {
    return features.find(function (feature) { return feature.id === id; });
}; };
exports.getNewState = (0, immer_1.default)(function (draft, newStates) {
    if (!newStates.length) {
        draft.splice(0, draft.length);
        return;
    }
    var findFeature = findFeatureById(newStates);
    draft.forEach(function (feature) {
        var newFeature = findFeature(feature.id);
        feature.featureData = __assign(__assign({}, feature.featureData), newFeature.featureData);
    });
    for (var i = 0; i < newStates.length; i++) {
        var index = draft.findIndex(function (feature) { return feature.featureData.status === FeatureInstanceStatus_1.FeatureInstanceStatus.Completed; });
        if (index !== -1) {
            draft.splice(index, 1);
        }
    }
});
